/* global jQuery Swiper */
(function ($, d) {
    $(d).ready(function () {

        // tabs triggers
        $('.lm-pills-tab a[data-bs-target]').on('show.bs.tab', function(e) {
            let target = $(e.target).data('bsTarget');
            console.log(target)

            $(target)
                .addClass('active show')
                .siblings('.tab-pane.active')
                .removeClass('active show')
        });

        // Open navbarSide when button is clicked
        $('#navbarSideButton').on('click', function () {
            $('#navbarSide').addClass('reveal');
            $('.overlayy').show();
        });

        // Close navbarSide when the outside of menu is clicked
        $('.overlayy').on('click', function () {
            $('#navbarSide').removeClass('reveal');
            $('.overlayy').hide();
        });


        /**
         * navbar on scroll
         */
        if (jQuery('body').hasClass('fruits-theme')) {
            var navbar = jQuery('.js-lm-navbar'),
                defaultPosition = {top: 0, left: 0}; //navbar.position();

            if ($(window).scrollTop() > 3) {
                navbar.addClass('on-scroll');
            }

            jQuery(window).scroll(function () {
                var windowPosition = jQuery(window).scrollTop();
                if (windowPosition >= defaultPosition.top & windowPosition < 3) {
                    navbar.removeClass('on-scroll');
                } else {
                    navbar.addClass('on-scroll');
                }
            })
        }

        $('.lm-tbox__title').on('click', function () {
            $(this).toggleClass('open');
            $(this).next('.lm-tbox__content').slideToggle();
        });

        $('.lm-accordion-item__title').on('click', function () {
            $(this).toggleClass('open');
            $(this).next('.lm-accordion-item__content').slideToggle();
        });

        //TODO make this file with porototypes, avoid ES6 and and make this file work only on Avocado theme

        $('.js-navbar-drawer-toggle-item').on('click', function (e) {
            if (!$(e.currentTarget).hasClass('active')) {
                $('.js-navbar-drawer-toggle-item.active').removeClass('active');
            }
            $(e.currentTarget).toggleClass('active');
        })

        $('.js-lm-navbar-burger, .js-navbar-drawer-overlay').on('click', function () {
            $('.js-navbar-drawer').toggleClass('active');
            $('.js-navbar-drawer-overlay').toggleClass('active');
        })

        $('.js-toggle-mt-app').on('click', function () {
            $('.section-navbar').toggleClass('active-float-app');
            $('.lm-app-card-wrap').toggleClass('active-float');
            $('.lm-sidebar__mobile-touch').toggleClass('active');
        });

        if (document.querySelector('.lm-floating-cta--flat:not(.activeForever)')) {
            window.addEventListener('scroll', function () {
                const mtAppWrap = document.querySelector('.lm-app-card-wrap');
                if (mtAppWrap) {
                    const offsetParent = mtAppWrap.offsetParent;
                    let viewportHeight = window.innerHeight;
                    let offsetTop = offsetParent.offsetTop + document.getElementById('mobile-touch').offsetHeight - 200;
                    // Check if offsetParent is lower than 150% of the viewport height
                    if (offsetParent.offsetTop < viewportHeight * 1.5) {
                        viewportHeight = viewportHeight /2;
                        offsetTop = viewportHeight;
                    }
                    const scrollTop = window.scrollY;
                    if (scrollTop > viewportHeight - 200 &&
                        scrollTop > offsetTop &&
                        !document.querySelector('.lm-app-card-wrap.active-float')) {
                        document.querySelectorAll('.lm-floating-cta--flat:not(.active)').forEach(el => {
                            el.classList.add('active');
                        });
                    } else {
                        document.querySelectorAll('.lm-floating-cta--flat').forEach(el => {
                            el.classList.remove('active');
                        });
                    }
                }
            });
        }

        function lm_swiper() {
            return new Swiper('.js-swiper-testimonials', {
                spaceBetween: 0,
                centeredSlides: true,
                slidesPerView: 'auto',
                initialSlide: 1,
                loop: true,
            });
        }

        function lm_posts_slider() {
            new Swiper('.js-posts-carousel.carousel--related-posts', {
                spaceBetween: 20,
                centeredSlides: false,
                slidesPerView: 2,
                initialSlide: 0,
                loop: true,
                speed:800,
                autoplay: true,
                navigation: {
                    nextEl: '.lm-swiper-button-next',
                    prevEl: '.lm-swiper-button-prev',
                },
                breakpoints: {
                    767: {
                        centeredSlides: true,
                        slidesPerView: 1,
                        initialSlide: 1
                    }
                }
            });
        }

        function lm_posts_slider_featured() {
            new Swiper('.js-posts-carousel.carousel--featured-posts', {
                spaceBetween: 20,
                centeredSlides: false,
                slidesPerView: 3,
                initialSlide: 0,
                loop: true,
                speed:800,
                autoplay: true,
                navigation: {
                    nextEl: '.lm-swiper-button-next',
                    prevEl: '.lm-swiper-button-prev',
                },
                breakpoints: {
                    1000: {
                        slidesPerView: 2,
                    },
                    767: {
                        centeredSlides: true,
                        slidesPerView: 1,
                        initialSlide: 1
                    }
                }
            });
        }

        function lm_posts_slider_cats() {
            new Swiper('.js-posts-carousel.carousel--cats.reverse-false', {
                spaceBetween: 20,
                centeredSlides: false,
                slidesPerView: 3,
                initialSlide: 0,
                loop: false,
                speed:800,
                autoplay: false,
                navigation: {
                    nextEl: '.lm-swiper-button-next',
                    prevEl: '.lm-swiper-button-prev',
                },
                breakpoints: {
                    1000: {
                        slidesPerView: 2,
                    },
                    767: {
                        centeredSlides: true,
                        slidesPerView: 1,
                        initialSlide: 1
                    }
                }
            });
        }

        function lm_posts_slider_cats_reverse() {
            new Swiper('.js-posts-carousel.carousel--cats.reverse-true', {
                spaceBetween: 20,
                centeredSlides: false,
                slidesPerView: 3,
                initialSlide: 20,
                loop: false,
                speed:800,
                autoplay: false,
                navigation: {
                    nextEl: '.lm-swiper-button-next',
                    prevEl: '.lm-swiper-button-prev',
                },
                breakpoints: {
                    1000: {
                        slidesPerView: 2,
                    },
                    767: {
                        centeredSlides: true,
                        slidesPerView: 1,
                        initialSlide: 20
                    }
                }
            });
        }

        function lm_posts_slider_cats_top() {
            new Swiper('.js-posts-carousel.carousel--financial-info-center-top', {
                init: true,
                loop: false,
                speed:800,
                initialSlide: 1,
                slidesPerView: 2, // or 'auto'
                // spaceBetween: 10,
                centeredSlides : true,
                effect: 'coverflow', // 'cube', 'fade', 'coverflow',
                coverflowEffect: {
                    rotate: 0, // Slide rotate in degrees
                    stretch: -30, // Stretch space between slides (in px)
                    depth: 100, // Depth offset in px (slides translate in Z axis)
                    modifier: 2, // Effect multipler
                    slideShadows : true, // Enables slides shadows
                },
                grabCursor: true,
                //parallax: true,
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                // },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    1023: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    }
                }
            });
        }


        $('.js-toggle-cats-menu').on('click', function () {
            $('.lm-cats-menu').toggleClass('active');
        });

        // TODO: make it clear, if get approve :)
        lm_swiper();
        lm_posts_slider();
        lm_posts_slider_featured();
        lm_posts_slider_cats();
        lm_posts_slider_cats_top();
        lm_posts_slider_cats_reverse();

        $('.js-nice-select').niceSelect();

        // if ($(window).width() > 991 && $('.lm-sidebar:not(.nostick)').length) {
            // window.LMStickySidebar = new StickySidebar('.lm-sidebar__inner', {
            //     topSpacing: 90,
            //     bottomSpacing: 30
            // });

            // $('.lm-sidebar').on('click', function () {
            //     window.LMStickySidebar.updateSticky()
            //     let i = 0;
            //     let int = setInterval(function () {
            //         window.LMStickySidebar.updateSticky()
            //         if (i > 6) {
            //             clearInterval(int)
            //         }
            //         i++;
            //     }, 300)
            // });
        // }

        $('.js-toggle-active').on('click', (e) => {
            $(e.currentTarget).toggleClass('active');
        });
    })
})(jQuery, document);
